/**
 * Normalizes the landing URL's `domain`/`region` query parameters at import time, before any
 * other module gets a chance to read `location.search`.
 *
 * This has to be its own module, imported first in src/index.tsx (right after the polyfills and
 * before every other import), because ES imports are evaluated before _init runs. Several modules
 * read the URL as a side effect of being imported -- ToolMenuConfigService (pulled in by
 * @atredux/store) builds the Seaward iframe path at load time, and the user-preferences client
 * fixes its stage at load time -- so calling normalizeLandingUrl() from _init (as this used to)
 * is too late on a bare regional host: those modules already finished reading an URL with no
 * domain/region, and nothing re-reads it afterwards.
 *
 * This module and @utils/AppHostUtil (its only import) must stay import-free (type-only imports
 * aside), or the same bug reappears one level down: anything that transitively imports
 * @amzn/ihm-associate-tools-js-lib -- @utils/RegionRealms included -- builds that library's
 * service clients at load time from the not-yet-normalized location.search.
 * test/bootstrap/normalizeLandingUrl.importIsolation.test.ts guards this.
 */

import { normalizeLandingUrl } from '@utils/AppHostUtil'

normalizeLandingUrl()
